import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { useAppContext } from '@contexts/app';
import { SpecialtiesDropdownRespSuccess } from './types';

export const useSpecialtiesDropdown = () => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const { data, error, isPending } = useQuery<SpecialtiesDropdownRespSuccess, ApiError>({
    queryKey: queryKeys.dropdowns.specialties,
    queryFn: () => queryFetch({ url: 'dropdowns/field_users_specialties' }),
    placeholderData: (previousData) => previousData as SpecialtiesDropdownRespSuccess,
    enabled,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
